import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

import { getType, handleApi } from '@/utils/common.js'

const policyButlerApi = {
  state: {
    searchModel: null
  },
  mutations: {
    setCacheSearchModel(state, data) {
      state.searchModel = data ? {...data} : null
    },
    getPolicyRutlerList(state, data) {
      data.url = API.policyRutler.list;
      CommonUtils.GetRequest(data);
    },
    getManpowerList(state, data) {
      data.url = API.policyRutler.manpowerList;
      CommonUtils.GetRequest(data);
    },
    getManpowerLechengList(state, data) {
      data.url = API.policyRutler.manpowerLechengList;
      CommonUtils.GetRequest(data);
    },
    getManpowerLechengListMW(state, data) {
      data.url = API.policyRutler.manpowerLechengListMW;
      CommonUtils.GetRequest(data);
    },
    // 基础信息
    getPolicyRutlerBaseInfo(state, data) {
      data.url = handleApi(API.policyRutler.baseInfo, getType('get_base_info', 'get_base_info_secret'))
      // data.url = API.policyRutler.baseInfo;
      CommonUtils.GetRequest(data);
    },
    // 客户信息
    getPolicyRutlerCustomerInfo(state, data) {
      data.url = handleApi(API.policyRutler.customerInfo, getType('get_customer_info', 'get_customer_info_secret', 'get_customer_info_part'))
      // data.url = API.policyRutler.customerInfo;
      CommonUtils.GetRequest(data);
    },
    // 险种信息
    getPolicyRutlerInsuranceInfo(state, data) {
      data.url = handleApi(API.policyRutler.insuareInfo, getType('get_insurance_list', 'get_insurance_list_secret'))
      // data.url = API.policyRutler.insuareInfo;
      CommonUtils.GetRequest(data);
    },
    // 支付信息
    getPolicyRutlerPayInfo(state, data) {
      data.url = handleApi(API.policyRutler.payInfo, getType('get_payment_info', 'get_payment_info_secret'))
      // data.url = API.policyRutler.payInfo;
      CommonUtils.GetRequest(data);
    },
    // 回访信息
    getPolicyRutlerVisitInfo(state, data) {
      data.url = handleApi(API.policyRutler.visitInfo, getType('get_visit_info', 'get_visit_info_secret'))

      // data.url = API.policyRutler.visitInfo;
      CommonUtils.GetRequest(data);
    },
    // 保全信息
    getPreservationInfo(state, data) {
      data.url = API.policyRutler.policyPreserveList;
      CommonUtils.GetRequest(data);
    },
    // 双录信息
    getDoubleRecordInfo(state, data) {
      data.url = API.policyRutler.doubleRecordList;
      CommonUtils.GetRequest(data);
    },
    // 销售信息
    getPolicyRutlerSalesInfo(state, data) {
      data.url = handleApi(API.policyRutler.salesInfo, getType('get_sales_info', 'get_sales_info_secret'))

      // data.url = API.policyRutler.salesInfo;
      CommonUtils.GetRequest(data);
    },
    // 关联保单信息
    getPolicyRutlerRelationInfo(state, data) {
      data.url = handleApi(API.policyRutler.relationInfo, getType('get_children_order_list', 'get_children_order_list_secret'))

      // data.url = API.policyRutler.relationInfo;
      CommonUtils.GetRequest(data)
    },
    // 续期信息
    getPolicyRutlerRenewalInfo(state, data) {
      data.url = handleApi(API.policyRutler.renewalInfo, getType('get_renewal_info', 'get_renewal_info_secret'))

      // data.url = API.policyRutler.renewalInfo;
      CommonUtils.GetRequest(data)
    },
    // 重新下载电子保单
    getPolicyRutlerReDownLoad(state, data) {
      data.url = handleApi(API.policyRutler.redownLoadUrl, getType('base_info_download_file', 'base_info_download_file_secret'))
      // data.url = API.policyRutler.redownLoadUrl;
      CommonUtils.GetRequest(data)
    },
    // 人核信息
    getPolicyRutlerManPower(state, data) {
      data.url = handleApi(API.policyRutler.manPower, getType('get_manpower_info', 'get_manpower_info_secret'))

      // data.url = API.policyRutler.manPower;
      CommonUtils.GetRequest(data)
    },
    // 人核信息(人核订单列表页面)
    getPolicyRutlerManPowerDetail(state, data) {
      data.url = API.policyRutler.manPowerDetail;
      CommonUtils.GetRequest(data)
    },
    exportOrder(state, data) {
      data.url = handleApi(API.policyRutler.exportFile, getType('export_policy_list', 'export_policy_list_secret'))

      // data.url = API.policyRutler.exportFile
      CommonUtils.GetRequest(data)
    },
    getPolicyRutlerOrderDetail(state, data) {
      data.url = API.policyRutler.detail;
      CommonUtils.GetRequest(data);
    },
    getPolicyRutlerSupplierList(state, data) {
      data.url = API.policyRutler.supplierList;
      CommonUtils.GetRequest(data);
    },
    getPolicyRutlerApiCpsProducts(state, data) {
      data.url = API.policyRutler.apiCpsProducts;
      CommonUtils.GetRequest(data);
    },
    getPolicyRutlerSalePlatforms(state, data) {
      data.url = API.policyRutler.salesPlatforms;
      CommonUtils.GetRequest(data);
    },
    getPolicySalePlatforms(state, data) {
      data.url = API.insurancePolicy.getSalesPlatforms
      CommonUtils.GetRequest(data);
    },
    FetchReplenish(state, data) {
      data.url = API.policyRutler.replenish
      CommonUtils.PostRequest(data);
    },
    FetchReplenishInfo(state, data) {
      data.url = handleApi(API.policyRutler.replenishInfo, getType('manual_supplement_info', 'manual_supplement_info_secret'))

      // data.url = API.policyRutler.replenishInfo
      CommonUtils.GetRequest(data);
    },
    FetchReplenishEdit(state, data) {
      data.url = API.policyRutler.replenishEdit
      CommonUtils.PostRequest(data);
    },
    FetchReplenishAdd(state, data) {
      data.url = API.policyRutler.replenishAdd
      CommonUtils.PostRequest(data);
    },
    FetchReplenishDelete(state, data) {
      data.url = API.policyRutler.replenishDelete
      CommonUtils.PostRequest(data);
    },
    RefreshLastUpdateTime(state, data) {
      data.url = API.policyRutler.refreshLastUpdateTime;
      CommonUtils.PostRequest(data);
    },
    // 编辑保障期间
    UpdateGuaranteePeriod(state, data) {
      data.url = API.policyRutler.updateGuaranteePeriod
      CommonUtils.PostRequest(data)
    },
    // 编辑缴费期间
    UpdatePaymentPeriod(state, data) {
      data.url = API.policyRutler.updatePaymentPeriod
      CommonUtils.PostRequest(data)
    },
    // 编辑频次
    UpdateFrequency(state, data) {
        data.url = API.policyRutler.updateFrequency
        CommonUtils.PostRequest(data)
    },
    // 修改基本信息
    BaseInfoEdit(state, data) {
      data.url = API.policyRutler.baseInfoEdit
      CommonUtils.PostRequest(data)
    },
    // 修改保单回访信息
    VisitInfoEdit(state, data) {
      data.url = API.policyRutler.visitInfoEdit
      CommonUtils.PostRequest(data)
    },
    GetServiceFee(state, data) {
      data.url = API.policyRutler.getServiceFee
      CommonUtils.GetRequest(data)
    },
  }
}

export default policyButlerApi



// WEBPACK FOOTER //
// ./src/store/modules/policy-butler.js